import React from "react";
import { delay, motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import {
  containerVariants,
  itemVariants,
  photoVariants,
} from "../../variants/variants";

const Section5 = () => {
  const { t } = useTranslation();
  const collaborationItems = t("rnd.collaborations.items", { returnObjects: true });



  return (
    <div className="grid grid-cols-10 pb-28">
      <div
        className="col-start-2 md:col-start-2 col-span-8 grid grid-cols-1 md:grid-cols-2">

        <motion.div
          initial="hidden"
          whileInView="visible"
          exit="exit"
          variants={containerVariants}

          className="flex flex-col">
          <motion.img src="/images/rand/yellow.svg" className="w-28" alt="Yellow Icon" />
          <motion.h2 variants={itemVariants} className="text-65 my-5">{t("rnd.collaborations.title")}</motion.h2>
          <motion.h5 variants={itemVariants} className="text-20 font-bold mb-5">
            {t("rnd.collaborations.scope")}
          </motion.h5>
          <div className="flex flex-col text-20 font-light tracking-wide space-y-2">
            {collaborationItems.map((detail, index) => (
              <motion.h6 variants={itemVariants} key={index}>{detail}</motion.h6>
            ))}
          </div>
        </motion.div>


        <motion.div
          initial="hidden"
          whileInView="visible"
          exit="exit"
          variants={containerVariants}
          className="flex flex-col justify-center mt-10 md:mt-24">
          <motion.h2 variants={itemVariants} className="text-40 md:text-50 mb-5 font-medium">
            {t("rnd.strategicPartnerships.title")}
          </motion.h2>
          <div className="flex flex-col text-18 font-light tracking-wide space-y-4 leading-relaxed">
            <motion.p variants={itemVariants}>
              {t("rnd.strategicPartnerships.text1")}
            </motion.p>
            <motion.p variants={itemVariants}>
              {t("rnd.strategicPartnerships.text2")}
            </motion.p>
            <motion.p variants={itemVariants}>
              {t("rnd.strategicPartnerships.text3")}
            </motion.p>
          </div>
        </motion.div>


      </div>
    </div>
  );
};

export default Section5;
